module.exports = __webpack_public_path__ + "a7438b9847a1c5a85c899fbc9547f38f.pdf";